"use client";

import { useEffect, useState } from "react";

export default function ProblemSolvedSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsVisible(true); },
      { threshold: 0.2 }
    );
    const section = document.getElementById('quote-section');
    if (section) observer.observe(section);
    return () => { if (section) observer.unobserve(section); };
  }, []);

  return (
    <section id="quote-section" className="bg-slate-50 dark:bg-slate-900 py-20 lg:py-28">
      <div className="container mx-auto max-w-5xl px-6 lg:px-8 text-center">
        <div className={`transition-all duration-700 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}>
          <blockquote className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 dark:text-white leading-snug tracking-tight">
            <span className="text-orange-400 dark:text-orange-500 font-serif">&ldquo;</span>
            Stop scrambling before calls. Start walking in prepared.
            <span className="text-orange-400 dark:text-orange-500 font-serif">&rdquo;</span>
          </blockquote>
        </div>
      </div>
    </section>
  );
}
